<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados Pessoais</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmPessoa" label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field :rules="[campoObrigatorio, campoCPF]" v-mask="maskCPF" v-model.trim="registro.nrDocumento" label="CPF" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs11 md11 ma-5>
                    <h3><b>Dados para Notificação</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field :rules="[campoObrigatorio, campoEmail]" v-model="registro.stEmail" label="E-mail" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field v-mask="maskCel" v-model="registro.nrCelular" label="Celular" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5 pl-3>
                    <v-switch color="info" v-model="registro.flAtivaNotificacao" label="Receber Notificações" ></v-switch>
                </v-flex>                
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoCPF, campoEmail } from '@/filters/rules'
import { formatCPF } from '@/filters/utils'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'
import { mask } from 'vue-the-mask'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'


export default {
    name: 'Tecnico',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    directives: {
        mask,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            maskCPF: '###.###.###-##',
            maskCel: '(##)#####-####',
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Extensionista: ' + this.registro.idResponsavelTecnico

                return 'Inserindo novo Extensionista'
            }
        },
    },
    methods: {
        campoObrigatorio,
        campoCPF,
        campoEmail,
        formatCPF,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('responsavel-tecnico/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.registro = Object.assign({}, rec)
                this.registroBanco = Object.assign({}, rec)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
                this.$router.push({ path: '/tecnico'})
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.$axios.post('responsavel-tecnico/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'tecnico', params: { id: response.data[0].data.idResponsavelTecnico }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadExtensionistas')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.$axios.put('responsavel-tecnico/' + this.registro.idResponsavelTecnico, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadExtensionistas')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('responsavel-tecnico/' + this.registro.idResponsavelTecnico)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadExtensionistas')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/tecnico' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idResponsavelTecnico: 0,
                nmPessoa: '',
                nrDocumento: '',
                stEmail: '',
                flAtivaNotificacao: false,
                nrCelular: '',
            }
            this.registroBanco = {
                idResponsavelTecnico: 0,
                nmPessoa: '',
                nrDocumento: '',
                stEmail: '',
                flAtivaNotificacao: false,
                nrCelular: '',
            }
        },
        goSearch() {
            this.$router.push({ path: '/tecnicoSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
